import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 - Lenea Evolinee"
        description="Siden du leder efter findes desværre ikke hos Lenea Evolinee. Vend tilbage til forsiden for at udforske mine forløb og fællesskaber."
      />

      <section className="min-h-[70vh] pt-36 pb-20 flex items-center justify-center bg-[#FAF7F2]">
        <div className="max-w-2xl mx-auto px-4 text-center space-y-6">
          <div className="w-16 h-16 rounded-full bg-[#98866C]/20 text-[#98866C] font-serif text-xl font-bold flex items-center justify-center mx-auto">
            404
          </div>

          <h1 className="font-serif text-4xl sm:text-5xl font-normal text-[#2E2A27]">
            Siden blev ikke fundet
          </h1>

          <p className="text-base text-[#5C524A] leading-relaxed max-w-md mx-auto font-sans">
            Du er måske havnet et forkert sted. Lad mig hjælpe dig med at finde tilbage til roen og helheden.
          </p>

          <div className="pt-4 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="px-7 py-3.5 bg-[#98866C] text-white text-xs uppercase tracking-widest font-medium hover:bg-[#83735C] transition-colors cursor-pointer"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/forlob"
              className="px-7 py-3.5 bg-[#FAF7F2] text-[#2E2A27] border border-[#D8CDBF] text-xs uppercase tracking-widest font-medium hover:bg-[#EAE3D5] transition-colors cursor-pointer"
            >
              Se forløb
            </Link>
            <Link
              to="/kontakt"
              className="px-7 py-3.5 bg-[#FAF7F2] text-[#2E2A27] border border-[#D8CDBF] text-xs uppercase tracking-widest font-medium hover:bg-[#EAE3D5] transition-colors cursor-pointer"
            >
              Kontakt mig
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
